module.exports = __webpack_public_path__ + "img/custom-09.82b28753.jpg";